import type { AgentExecutionDto } from '@terra/shared-contracts-agent-execution';
import { agentExecutionClient } from '@terra/shared-rest-clients-agent-execution';

export const AGENT_EXECUTIONS_BY_TARGET_KEY = 'agent-executions-by-target';

export async function fetchAgentExecutionsByTarget({
  targetId,
  skip,
  limit,
  executionType,
  scanId,
}: {
  targetId: string;
  skip: number;
  limit: number;
  executionType?: AgentExecutionDto['executionType'];
  scanId?: string;
}) {
  const response = await agentExecutionClient.findByTarget({
    params: { targetId },
    query: {
      archived: false,
      skip,
      limit,
      executionType,
      scanId,
    },
  });

  if (response.status !== 200) {
    throw new Error('Failed to fetch agent executions');
  }

  return {
    executions: response.body.executions,
    totalCount: response.body.totalCount,
  };
}
